import { render, staticRenderFns } from "./PreviewPopup.vue?vue&type=template&id=4bd9624b&scoped=true&"
import script from "./PreviewPopup.vue?vue&type=script&lang=js&"
export * from "./PreviewPopup.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPopup.vue?vue&type=style&index=0&id=4bd9624b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9624b",
  null
  
)

export default component.exports